import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useEffect } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import ReassuranceSection from "./ReassuranceSection";

window.$ = window.jQuery = $;

function Layout(props) {
const reassurance = props?.data?.reassurance_blocks || [];


const headerTop = reassurance.filter(
  i => i.header_position === "above_header"
);

const headerBottom = reassurance.filter(
  i => i.header_position === "below_header"
);

const footerBottom = reassurance.filter(
  i => i.footer_position === "below_footer"
);

// DEFAULT SLOT: above footer
const footerTop = reassurance.filter(i => {
  return (
    i.footer_position === "above_footer" ||
    (
      (i.header_position === "none" || !i.header_position) &&
      (i.footer_position === "none" || !i.footer_position)
    )
  );
});


  useEffect(() => {
    props.reduxCommonContent();
    let scrollFrame = 0;

    const handleScroll = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        document.querySelector(".header")?.classList.toggle("scrll", window.scrollY >= 10);
        scrollFrame = 0;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    };

  }, []);

return (
  <>
  <ReassuranceSection items={headerTop} />


    <Header 
      data={props?.data?.header_menu} 
      site_settings={props?.data?.site_settings} 
      agc_menu={props?.data?.agc_header_menu}
      cart={props?.data?.cart}
    />
<ReassuranceSection
  items={headerBottom}
  reserveSpace={!props.commonLoaded}
/>
    <main className="site-main">
      <Outlet context={props?.data?.categories} />
    </main>
<ReassuranceSection items={footerTop} />


<Footer 
        data={props?.data?.footer_menu} 
        agc_footer_menu={props?.data?.footer_agc_menu}
        categories={props?.data?.footer_categories} 
        site_settings={props?.data?.site_settings}
      />
<ReassuranceSection items={footerBottom} />
    {props.loader && (
      <div
        className="position-fixed top-0 start-0 w-100 vh-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
        style={{ zIndex: 99999 }}
      >
        <div className="spinner-border text-light" role="status" />
      </div>
    )}
  </>
);
}

const mapStateToProps = state => {
  return {
    data: state.home.common_data,
    loader: state.home.common_loader,
    commonLoaded: state.home.common_loaded,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reduxCommonContent: () =>
      dispatch({
        type: 'CcommonContent_sync',
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
